<img width="108" [src]="dataUrl$|async" class="car-img"/>
